<template>
  <div class="container">
    <div class="level-template">
      <div class="btn-wrapper">
        <el-button class="add-new-btn" @click="handleViewAdd(1)">
          <i class="iconfont iconProperty1tianjia"></i> Add
        </el-button>
      </div>
      <div class="risk-table risklist-table">
        <el-table
          ref="table"
          :data="list"
          :height="tableHeight"
          :indent="0"
          v-loading="loading"
          header-row-class-name="table-header-row"
          border
          row-key="rowId"
          :tree-props="{children: 'childList', hasChildren: 'hasChildren'}"
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="Promotions Template ID" prop="id" min-width="150px" align="left">
            <template v-slot="{row}">
              <div style="text-align: left;">{{ row.id }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Promotions Template Name" min-width="220px" align="left">
            <template v-slot="{row}">
              {{ row.templateName }}
            </template>
          </el-table-column>
          <el-table-column label="Status" align="left">
            <template v-slot="{row}">
              <el-switch 
                v-model="row.promotionStatus" 
                :loading="statusLoadingMap[row.id] || false"
                :disabled="statusLoadingMap[row.id] || false"
                @change="handleStatusChange(row)" 
              />
            </template>
          </el-table-column>
          <el-table-column label="Last Update Time" min-width="160px" align="left">
            <template v-slot="{row}">
              <div v-if="row.updateTime">{{ formatUtc(row.updateTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Operation" align="center">
            <template v-slot="{row}">
              <div>
                <el-button class="table-inner-btn" @click="handleViewAdd(2,row)">Modify</el-button>
                <!-- <el-button
                  class="table-inner-btn"
                  :disabled="row.id == 1"
                  @click="handleViewAdd(3,row)"
                >Delete</el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="pagination-wrapper inline-wrapper">
        <el-pagination
          class="inline-right"
          :total="total"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :page-sizes="[50, 100, 200]"
          @current-change="changePage"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>-->
    </div>

    <dia ref="diaListDom" class="label-dialog">
      <!-- 添加1修改2 -->
      <div v-if="num == 2 || num == 1">
        <el-form :model="queryForm" label-width="190px">
          <el-form-item label="Promotions Template ID">
            <el-input v-model="queryForm.id" disabled></el-input>
          </el-form-item>
          <el-form-item label="Promotions Template Name">
            <el-input v-model="queryForm.templateName"></el-input>
          </el-form-item>

          <el-form-item label="Status">
            <el-switch v-model="queryForm.promotionStatus" />
          </el-form-item>
          <!-- {{ getSelectedIds() }} -->
          <el-form-item label="Promotions/User Level Matrix">
            <!-- 表格 -->
            <el-table :data="levelList" border overflow-x="auto">
              <el-table-column label=" " prop="Promotions" width="160" align="center">

              </el-table-column>
              <el-table-column label="All" width="60" align="center">
                <template v-slot="{row}">
                  <el-checkbox 
                    :value="getRowAllChecked(row)" 
                    :indeterminate="getRowIndeterminate(row)"
                    @change="(val) => handleRowAllChange(row, val)"
                  />
                </template>
              </el-table-column>
              <el-table-column v-for="column in levelColumns" :key="column.id" :label="column.name" width="120" align="center">
                <template v-slot="{row}">
                  <el-checkbox 
                    :value="getColumnChecked(row, column.id)" 
                    @change="(val) => handleColumnChange(row, column, val)"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleListModify(num)">Confirm</el-button>
          <el-button class="clear-btn" @click="listClose()">Cancel</el-button>
        </div>
      </div>
      <!-- 删除3 -->
      <div class="dialog-footer table-search-part" v-if="num == 3">
        <el-button class="search-btn" @click="Delete()">Confirm</el-button>
        <el-button class="clear-btn" @click="listClose()">Cancel</el-button>
      </div>
    </dia>
  </div>
</template>
<script>
import Empty from "@/components/empty/index";
import dia from "@/components/dialog/index";
import {
  getPromotionTemplateList,
  addPromotionTemplate,
  updatePromotionTemplate,

  getTemplateDelete,
  updateBatchPublishGlobalSetting,
  publish
} from "@/api/channel";
import { getList as getLevelList } from "@/api/level";

export default {
  components: {
    Empty,
    dia
  },
  data() {
    return {
      list: [],
      levelList: [],
      status: false,
      total: 0,
      loading: false,
      num: "",
      templateId: "",
      data: [],
      queryForm: {
        id: "",
        templateName: "",
        promotionStatus: false,
      },
      queryData: {
        pageNum: 1,
        pageSize: 100
      },
      tableHeight: window.innerHeight,
      levelColumns: [],
      statusLoadingMap: {}
    };
  },
  mounted() {
    this.getLevelList();
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  },
  methods: {
    handleStatusChange(row) {
      if (this.statusLoadingMap[row.id]) {
        return;
      }
      
      this.$set(this.statusLoadingMap, row.id, true);
      
      updatePromotionTemplate(row)
        .then(res => {
          if (res.success) {
            this.$message({ message: "update status success", type: "success" });
            this.getList();
          } else {
            row.promotionStatus = !row.promotionStatus;
          }
        })
        .catch(error => {
          row.promotionStatus = !row.promotionStatus;
          this.$message({ message: error.message, type: "error" });
        })
        .finally(() => {
          this.$set(this.statusLoadingMap, row.id, false);
        });
    },
    async getLevelList() {
      const res = await getLevelList({
        current: 1,
        size: 999
      });
      const levelList = res.data.records || [];
      this.levelColumns = [
        { name: 'Blank User', id: '0' },
        ...levelList.map(e => {
          return {
            name: e.name,
            id: e.id
          }
        })
      ];
      // 如果已有数据，保持原有选中状态；否则初始化为未选中
      const shouldPreserveData = this.levelList && this.levelList.length > 0;
      const existingData = shouldPreserveData ? this.levelList : null;
      
      this.levelList = [
        levelList.reduce((acc, cur) => {
          acc[cur.id] = existingData && existingData[0] && existingData[0][cur.id] !== undefined 
            ? existingData[0][cur.id] 
            : false;
          return acc;
        }, {
          Promotions: 'Soccer Early Payout',
          'Blank User': '0'
        }),
        levelList.reduce((acc, cur) => {
          acc[cur.id] = existingData && existingData[1] && existingData[1][cur.id] !== undefined 
            ? existingData[1][cur.id] 
            : false;
          return acc;
        }, {
          Promotions: 'Basketball Early Payout',
          'Blank User': '0'
        })
      ];
      return Promise.resolve();
    },
    async getList() {
      this.loading = true;
      const res = await getPromotionTemplateList(this.queryData);
      this.list = res.data || [];
      this.total = Number(res.total);
      this.loading = false;
    },
    // async publishFun() {
    //   const pub = await publish({});
    // },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "1000px");
    },
    CloseHistory() {
      this.$refs["diaListDom"].isShowDia(this.title, false, "1000px");
    },
    handleViewAdd(num, data) {
      this.num = num;
      if (num == 1) {
        // 添加
        this.title = "Add Bonus Template";
        this.queryForm = {
          id: "",
          templateName: "",
          promotionStatus: false,
        };
        // 清空旧状态，避免 getLevelList() preserve
        this.levelList = [];
        this.getLevelList(); // 重新生成全 false 的矩阵
        this.$refs["diaListDom"].isShowDia(this.title, true, "1000px");
      } else if (num == 2) {
        // 修改
        this.title = "Modify Bonus Template";
        this.queryForm = {
          id: data.id,
          templateName: data.templateName,
          promotionStatus: data.promotionStatus,
        };
        const detailConfigs = data.detailConfigs || [];
        
        // 确保 levelList 已初始化，然后恢复选中状态
        if (this.levelList && this.levelList.length > 0) {
          this.$nextTick(() => {
            this.restoreSelectedFromDetailConfigs(detailConfigs);
          });
        } else {
          // 如果还没初始化，先初始化再恢复
          this.getLevelList().then(() => {
            this.$nextTick(() => {
              this.restoreSelectedFromDetailConfigs(detailConfigs);
            });
          });
        }
        
        this.$refs["diaListDom"].isShowDia(this.title, true, "1000px");
      } else {
        // 删除
        this.title = "Delete Template?";
        this.templateId = data.id;
        this.$refs["diaListDom"].isShowDia(this.title, true, "1000px");
      }
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    async handleListModify(type) {
      const selectedIds = this.getSelectedIds();
      let param = {
        ...this.queryForm,
        detailConfigs: [
          {
            promotionId: 1001,
            allUserStatus: this.getRowAllChecked(this.levelList[0]),
            enableLevelIds: selectedIds[0],
          },
          {
            promotionId: 3001,
            allUserStatus: this.getRowAllChecked(this.levelList[1]),
            enableLevelIds: selectedIds[1],
          },
        ]
      };

      // if(param) return
      try {
        const res = await (type == 2 ? updatePromotionTemplate(param) : addPromotionTemplate(param) )
        if (res.success) {
          this.$message({ message: "update success", type: "success" });
          this.getList();
          // this.publishFun();
          this.listClose();
        }
      } catch (error) {
        this.listClose();
      }
    },
    listClose() {
      this.statusLoadingMap = {}
      this.$refs["diaListDom"].isShowDia(this.title, false, "1000px");
    },
    // 删除
    async Delete() {
      const res = await getTemplateDelete({ templateId: this.templateId });
      if (res.code == 0) {
        this.$message({ message: "delete success", type: "success" });
        this.getList();
        this.listClose();
      }
    },
    // 分页
    changePage(e) {
      this.queryData.pageNum = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.pageSize = e;
      this.queryData.pageNum = 1;
      this.getList();
    },
    // 获取列的选中状态（用于显示 checkbox）
    getColumnChecked(row, columnName) {
      if (!row || !columnName) return false;
      const value = row[columnName];
      return !!(value && value !== false);
    },
    // 获取行的全选状态
    getRowAllChecked(row) {
      return this.levelColumns.every(column => {
        const value = row[column.id];
        return value && value !== false;
      });
    },
    // 获取行的 indeterminate 状态（部分选中）
    getRowIndeterminate(row) {
      const hasChecked = this.levelColumns.some(column => {
        const value = row[column.id];
        return value && value !== false;
      });
      const allChecked = this.levelColumns.every(column => {
        const value = row[column.id];
        return value && value !== false;
      });
      // 有选中但不是全部选中，则显示 indeterminate
      return hasChecked && !allChecked;
    },
    handleRowAllChange(row, val) {
      this.levelColumns.forEach(column => {
        this.$set(row, column.id, val ? column.id : false);
      });
    },
    handleColumnChange(row, column, val) {
      this.$set(row, column.id, val ? column.id : false);
    },
    getSelectedIds() {
      const selectedIds = {
        0: [],
        1: []
      }
      this.levelList.forEach((row, id) => {
        this.levelColumns.forEach(column => {
          const value = row[column.id];
          if (value && value !== false) {
            selectedIds[id].push(column.id);
          }
        });
      });
      return selectedIds;
    },
    // 根据 detailConfigs 恢复选中状态
    restoreSelectedFromDetailConfigs(detailConfigs) {
      if (!detailConfigs || detailConfigs.length === 0) {
        return;
      }
      
      detailConfigs.forEach((config, index) => {
        // 确保索引在范围内
        if (index >= this.levelList.length) {
          return;
        }
        
        const row = this.levelList[index];
        const enableLevelIds = config.enableLevelIds || [];

        const levelIdsArray = Array.isArray(enableLevelIds) ? enableLevelIds : [];
        
        this.levelColumns.forEach(column => {
          this.$set(row, column.id, false);
        });
        
        // 恢复每个列的选中状态
        this.levelColumns.forEach(column => {
          const columnIdStr = String(column.id);
          const isSelected = levelIdsArray.some(id => String(id) === columnIdStr);
          
          if (isSelected) {
            this.$set(row, column.id, column.id);
          }
        });
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 30px;
  line-height: 30px;
  .total-box {
    display: flex;
    align-items: flex-start;
    margin: 10px 0;
    .total-setting {
      display: flex;
      align-items: center;
      border: 1px solid #f5f5f5;
      border-radius: 10px;
      width: 1200px;
      height: 67px;
      margin-right: 20px;
      .title {
        width: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333;
        font-size: 16px;
        font-weight: 700;
        height: 65px;
        border-right: 1px solid #f5f5f5;
      }
      .title-head {
        display: flex;
        flex: 1;
        flex-direction: column;
        height: 65px;
        border-right: 1px solid #f5f5f5;
        &:last-child {
          border: none;
        }
        p {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 33px;
          color: #666;
          font-size: 12px;
          &:first-child {
            border-bottom: 1px solid #f5f5f5;
            color: #333 !important;
          }
        }
      }
    }
    .edit-btn {
      background: #f8f8f8;
      border: 1px solid #f5f5f5;
    }
  }
  .level-template {
    .btn-wrapper {
      margin-bottom: 15px;
      text-align: right;
      .add-new-btn {
        background: #00a791 !important;
        color: #fff !important;
      }
    }
    .level-box {
      display: flex;
      align-items: left;
      flex-direction: column;
      .default {
        background: #e1554f;
        padding: 4px 6px 3px;
        border-radius: 15px;
        color: #fff;
        width: 90px;
        text-align: center;
      }
    }
  }
}
.el-select {
  width: 100%;
}
</style>
